/**
 * 主题色工具：活动页列表背景等
 */

function parseHex(hex) {
  if (!hex) return null
  let c = String(hex).replace('#', '').trim()
  if (c.length === 3) {
    c = c.split('').map((x) => x + x).join('')
  }
  if (c.length !== 6) return null
  const num = parseInt(c, 16)
  if (Number.isNaN(num)) return null
  return {
    r: (num >> 16) & 0xff,
    g: (num >> 8) & 0xff,
    b: num & 0xff,
  }
}

/** 向白色靠拢，amount 越大越接近白（0~1） */
export function lightenHex(hex, amount = 0.5) {
  const rgb = parseHex(hex)
  if (!rgb) return null
  const mix = (v) => Math.min(255, Math.round(v + (255 - v) * amount))
  const toHex = (v) => v.toString(16).padStart(2, '0')
  return `#${toHex(mix(rgb.r))}${toHex(mix(rgb.g))}${toHex(mix(rgb.b))}`
}

/** 活动商品列表区背景色：主题色浅 tint，行业常见约 85%~92% 掺白 */
export function getActivityListBackground(themeColor, amount = 0.88) {
  return lightenHex(themeColor, amount) || '#f5f5f5'
}

/** Banner 下方分类区背景：与礼包首页 categorySectionStyle 一致 */
export function getCategorySectionBackgroundStyle(themeColor) {
  if (!themeColor) return {}
  const end = lightenHex(themeColor, 0.35) || themeColor
  return {
    background: `linear-gradient(135deg, ${themeColor} 0%, ${end} 100%)`,
    transition: 'background 0.4s ease',
  }
}

/** 解析 hex 为 rgb 对象 */
export function hexToRgb(hex) {
  const parsed = parseHex(hex)
  if (!parsed) return { r: 107, g: 200, b: 234 }
  return parsed
}

/** 商城首页默认顶栏色 */
export const HOME_DEFAULT_TOP_COLOR = '#6bc8ea'

export const HOME_BANNER_THEME_STORAGE_KEY = 'homeBannerThemeColor'
export const HOME_BANNER_INDEX_STORAGE_KEY = 'homeBannerThemeIndex'

export function getStoredHomeBannerThemeIndex() {
  try {
    const raw = sessionStorage.getItem(HOME_BANNER_INDEX_STORAGE_KEY)
    const index = parseInt(raw, 10)
    return Number.isNaN(index) || index < 0 ? 0 : index
  } catch (e) {
    return 0
  }
}

export function getStoredHomeBannerThemeColor() {
  try {
    return sessionStorage.getItem(HOME_BANNER_THEME_STORAGE_KEY) || HOME_DEFAULT_TOP_COLOR
  } catch (e) {
    return HOME_DEFAULT_TOP_COLOR
  }
}

export function setStoredHomeBannerThemeColor(color, index) {
  if (!color) return
  try {
    sessionStorage.setItem(HOME_BANNER_THEME_STORAGE_KEY, color)
    if (index != null && index >= 0) {
      sessionStorage.setItem(HOME_BANNER_INDEX_STORAGE_KEY, String(index))
    }
  } catch (e) {
    // ignore
  }
}

/** 礼包首页默认顶栏色 */
export const GIFT_PACKAGE_DEFAULT_TOP_COLOR = '#667eea'

export const GIFT_PACKAGE_BANNER_THEME_STORAGE_KEY = 'giftPackageBannerThemeColor'
export const GIFT_PACKAGE_BANNER_INDEX_STORAGE_KEY = 'giftPackageBannerThemeIndex'

export function getStoredGiftPackageBannerThemeIndex() {
  try {
    const raw = sessionStorage.getItem(GIFT_PACKAGE_BANNER_INDEX_STORAGE_KEY)
    const index = parseInt(raw, 10)
    return Number.isNaN(index) || index < 0 ? 0 : index
  } catch (e) {
    return 0
  }
}

export function getStoredGiftPackageBannerThemeColor() {
  try {
    return sessionStorage.getItem(GIFT_PACKAGE_BANNER_THEME_STORAGE_KEY) || GIFT_PACKAGE_DEFAULT_TOP_COLOR
  } catch (e) {
    return GIFT_PACKAGE_DEFAULT_TOP_COLOR
  }
}

export function setStoredGiftPackageBannerThemeColor(color, index) {
  if (!color) return
  try {
    sessionStorage.setItem(GIFT_PACKAGE_BANNER_THEME_STORAGE_KEY, color)
    if (index != null && index >= 0) {
      sessionStorage.setItem(GIFT_PACKAGE_BANNER_INDEX_STORAGE_KEY, String(index))
    }
  } catch (e) {
    // ignore
  }
}

export function isGiftPackageMallSource() {
  try {
    return localStorage.getItem('mallSource') === 'giftPackage'
  } catch (e) {
    return false
  }
}

/**
 * 顶部渐变背景：取 Banner 顶部主题色，向下过渡到页面底色
 */
export function getHomeTopBackgroundStyle(themeColor, height = '12rem', defaultColor = HOME_DEFAULT_TOP_COLOR) {
  const base = themeColor || defaultColor
  const mid = lightenHex(base, 0.2) || base
  const bottom = lightenHex(base, 0.72) || '#f5f5f5'
  return {
    backgroundImage: `linear-gradient(180deg, ${base} 0%, ${mid} 38%, ${bottom} 72%, #f5f5f5 100%)`,
    backgroundSize: `100% ${height}`,
    backgroundRepeat: 'no-repeat',
    transition: 'background-image 0.45s ease',
  }
}
